import { generatePath } from "react-router";

import { LangCode } from "@/lib/gql/__generated__/graphql";
import { PageMeta } from "@/lib/react-helmet-async";

import { PATHS } from "@/routes/paths";

import { DayTripPlanEditContainer } from "@/components/features/items/edit/plan/day-trip/default/ui/existing/container";

import { useGetPlanEditPageParams } from "./_hooks/use-get-plan-edit-page-params";

export const ExistingDayTripPlanEditPage = () => {
	const { hotelID, planID } = useGetPlanEditPageParams();
	const activeLangCode = LangCode.Default;

	const navigator = {
		default: generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT, { hotelID, planID }),
		i18n: (langCode: LangCode) =>
			generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.I18N, { hotelID, planID, langCode }),
	};

	return (
		<PageMeta
			title="日帰りプランの編集"
			url={generatePath(PATHS.HOTEL.ITEMS.PLAN.EDIT.PLAN_ID.DAYTRIP.DEFAULT, { hotelID, planID })}
		>
			<DayTripPlanEditContainer
				hotelID={hotelID}
				planID={planID}
				activeLangCode={activeLangCode}
				navigator={navigator}
			/>
		</PageMeta>
	);
};

ExistingDayTripPlanEditPage.displayName = "ExistingDayTripPlanEditPage";
